module.exports = __webpack_public_path__ + "static/agus-valores-5aed7af0d4559b5b99c195b8a259ece0.svg";